import React, { useState } from 'react';
import { LuArrowLeft, LuCircleCheck } from 'react-icons/lu';
import BotonProgreso from '../ui/BotonProgreso';
import FirmasCierre from '../ui/FirmasCierre';

// Último paso del cierre por N/S (22-oct-2026): resumen de los equipos, observación de la visita y
// firmas, una sola vez para toda la visita. Recién acá se manda todo y se cierra el trabajo.
// Si quedan equipos del pedido sin cargar, se avisa y se pide el motivo antes de cerrar.

const INPUT = 'w-full px-3 py-2.5 rounded-xl bg-panel text-ink text-caption font-medium outline-none border border-black/[0.05] dark:border-white/[0.05] placeholder:text-muted';

export default function PasoCierreSerie({ items, sinCargar, observaciones, onObservaciones, firmas, onFirmas, guardando, progreso = null, onVolver, onFinalizar, conOrden }) {
    const [avisoPendientes, setAvisoPendientes] = useState(false);
    const faltaMotivo = sinCargar > 0 && !observaciones.trim();

    const finalizar = () => {
        if (sinCargar > 0 && !avisoPendientes) { setAvisoPendientes(true); return; }
        if (faltaMotivo) return;
        onFinalizar();
    };

    return (
        <>
            <button type="button" onClick={onVolver} className="mb-3 flex items-center gap-1.5 text-caption font-bold text-secondary active:scale-95">
                <LuArrowLeft size={14} /> Volver a los equipos
            </button>

            <p className="text-label font-black uppercase text-muted mb-1.5">Equipos de la visita</p>
            <div className="space-y-1.5 mb-4">
                {items.map(it => (
                    <div key={it.serie} className="p-2.5 rounded-xl bg-page flex items-start gap-2">
                        <LuCircleCheck size={15} className="shrink-0 mt-0.5 text-[color:var(--etapa-listo)]" />
                        <div className="min-w-0">
                            <p className="text-caption font-black text-ink">{it.serie}</p>
                            <p className="text-label text-muted">{it.trabajo}</p>
                        </div>
                    </div>
                ))}
            </div>

            <p className="text-label font-black uppercase text-muted mb-1.5">
                Observación de la visita {sinCargar > 0 && avisoPendientes ? '(obligatoria)' : '(opcional)'}
            </p>
            <textarea value={observaciones} onChange={e => onObservaciones(e.target.value)} rows={2}
                placeholder={sinCargar > 0 ? 'Por qué no se hizo el equipo que falta…' : 'Algo que quieras dejar anotado de toda la visita'}
                className={INPUT + ' mb-4'} />

            <p className="text-label font-black uppercase text-muted mb-1.5">Firmas (opcional)</p>
            <FirmasCierre value={firmas} onChange={onFirmas} />

            {avisoPendientes && sinCargar > 0 && (
                <div className="mt-3 p-3 rounded-xl bg-[var(--warning-bg)] border border-[var(--estado-curso)]">
                    <p className="text-caption font-black text-[var(--warning-tx)]">
                        {sinCargar === 1 ? 'Queda 1 equipo del pedido sin cargar.' : `Quedan ${sinCargar} equipos del pedido sin cargar.`}
                    </p>
                    <p className="text-caption text-secondary mt-1">
                        Si finalizás, la visita se cierra sin {sinCargar === 1 ? 'ese equipo' : 'esos equipos'}. Escribí arriba por qué no se hizo.
                    </p>
                </div>
            )}

            {guardando ? (
                <div className="mt-3"><BotonProgreso progreso={progreso} /></div>
            ) : (
                <button type="button" onClick={finalizar} disabled={avisoPendientes && faltaMotivo}
                    className="w-full mt-3 h-12 rounded-xl font-black text-label uppercase bg-brand-red text-white active:scale-95 disabled:opacity-40">
                    {avisoPendientes && sinCargar > 0 ? 'Finalizar igual'
                        : conOrden ? `Finalizar trabajo · ${items.length} equipo${items.length !== 1 ? 's' : ''}`
                            : `Guardar ${items.length} equipo${items.length !== 1 ? 's' : ''}`}
                </button>
            )}
        </>
    );
}
